const validateFileEnding = (file, allowedTypes) => {
    if (Array.isArray(file)) {
        let invalidFile = null;
        const allFilesValid = file.every(({ file: f }, idx) => {
            const isFileValid = allowedTypes.some((ending) => f.name.endsWith(ending));
            if (!isFileValid) {
                invalidFile = {
                    file: f,
                    idx,
                };
            }
            return isFileValid;
        });
        return [allFilesValid, invalidFile];
    }
    return allowedTypes.some((ending) => file.name.endsWith(ending));
};
export default validateFileEnding;
